import { render, staticRenderFns } from "./ChatClient.vue?vue&type=template&id=1bfce942&scoped=true&"
import script from "./ChatClient.vue?vue&type=script&lang=js&"
export * from "./ChatClient.vue?vue&type=script&lang=js&"
import style0 from "./ChatClient.vue?vue&type=style&index=0&id=1bfce942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfce942",
  null
  
)

export default component.exports